import type { GetSoftwareAccountsParams } from './-query/type';
export const ACCOUNT_TAB_FILTER = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED',
  SUSPENDED: 'SUSPENDED',
  ALL: 'ALL'
} as const;
export type AccountTabFilter = (typeof ACCOUNT_TAB_FILTER)[keyof typeof ACCOUNT_TAB_FILTER];
export type AccountOrderBy = Exclude<GetSoftwareAccountsParams['orderBy'], undefined>;
export const ACCOUNT_ORDER_BY = {
  APP_USER: 'APP_USER',
  APP_USER_ROLE: 'APP_USER_ROLE',
  EMAIL: 'EMAIL',
  EXTERNAL_STATUS: 'EXTERNAL_STATUS',
  INTERNAL_STATUS: 'INTERNAL_STATUS',
  LAST_SIGNED_IN_AT: 'LAST_SIGNED_IN_AT'
} as const satisfies Record<string, AccountOrderBy>;
type ApiAccountTypeFilter = NonNullable<GetSoftwareAccountsParams['accountType']>;

/**
 * アカウント種別フィルタの選択肢。UI 値と API 値が一致するためマッピング関数は不要。
 *
 * USER は「override が SYSTEM でないすべて（未設定を含む）」を意味する（BE 側の述語が正）。
 * 「システムアカウント以外」ではなく「ユーザーアカウント」と表示するのはこの意味論に沿う。
 */
export const ACCOUNT_TYPE_FILTER = {
  SYSTEM: 'SYSTEM',
  USER: 'USER'
} as const satisfies Record<string, ApiAccountTypeFilter>;
export type AccountTypeFilter = (typeof ACCOUNT_TYPE_FILTER)[keyof typeof ACCOUNT_TYPE_FILTER];
type ApiActiveStatusFilter = NonNullable<GetSoftwareAccountsParams['activeStatus']>;

// UI 上の「Suspended」タブは内部的には DEACTIVATED ユーザーをフィルタする。
// URL/i18n キーとの後方互換のためタブキーは SUSPENDED のままとし、API 送信時のみ
// DEACTIVATED にマッピングする (DC-6659)。
export const tabToActiveStatusFilter = (tab: AccountTabFilter): ApiActiveStatusFilter | undefined => {
  switch (tab) {
    case ACCOUNT_TAB_FILTER.ALL:
      return undefined;
    case ACCOUNT_TAB_FILTER.SUSPENDED:
      return 'DEACTIVATED';
    case ACCOUNT_TAB_FILTER.ACTIVE:
    case ACCOUNT_TAB_FILTER.INVITED:
      return tab;
  }
};

/**
 * アカウント一覧の部品（`FilterInput` / `DataScreen`）を置くルート。既存の Software 詳細と、テナント横断モードの
 * Software 詳細（DC-8783 決定 U12。子会社紐付きの行と越境紐付けの操作はこちらだけ）。検索パラメータの形は同じ
 */
export type AccountsRoutePath = '/software/$id/accounts' | '/cross-tenant/software/$id/accounts';